import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminStats = lazy(() => import("@/pages/admin/AdminStats"));

export const Route = createFileRoute("/admin/statistik/")({
  component: () => <AdminStats />,
});
